export default "__VITE_ASSET__e915195b__"